module.exports = {
  background: '#FFFFFF',
  backgroundDark: '#dfe3ee',

  primary: '#0084A1',
  primaryLight: '#007CB7',
  primaryDark: '#00656B',

  secondary: '#FF6F61',
  secondaryLight: '#FF6F61',
  secondaryDark: '#007CB7',
};
